import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import i18n from "../../../utilities/i18n";
import {
  ROUTE_PRACTICES,
  LOGIN_ROUTE,
  ROUTE_FORCE_RESET_PASSWORD,
  ROUTE_FORGOT_SEND_MAIL,
} from "../../../utilities/staticConfigs";
import "./style.css";
import service from "../service";
import {
  Grid,
  Box,
  Button,
  TextField,
  CssBaseline,
  IconButton,
  Typography,
} from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { styled } from '@mui/material/styles';
import { getStorage, setStorage } from "../../../utilities/browserStorage";
import { useDispatch, useSelector } from "react-redux";
import { setInitialState } from "../../../store/patient/patientInfoSlice";
import { setOtherBillingInitalState } from "../../../store/patient/PatientBillingInfo/patientBillingSlice";
import { extractPermissions, getPathToRouteOnLoginToAdminModule, getPathToRouteOnLoginToPractice } from "../../../utilities/commonUtilities";
import Label from "../../commons/Label";
import LoadingContext from "../../../container/loadingContext";
import Notify from "../../commons/notify";
import LoginHeader from "../Components/LoginHeader";
import packageJson from "../../../../package.json"
import LoginErrorAlert from "../Components/LoginAlert";
// import { errorBorder, normalBorder } from "../../reports/constants";
import workerManager from '../tokenWorkerManager';
const RootContainer = styled(Grid)(() => ({
  height: '100vh',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(159deg, #E6F1FD 0%, #E6F1FD 100%)',
  backgroundAttachment: 'fixed',
}));

const PaperWrapper = styled('div')(() => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const LoginCardBox = styled(Box)(({ theme }) => ({
  maxWidth: 500,
  margin: 'auto',
  padding: theme.spacing(3),
}));

const LoginCardContainer = styled(Grid)(({ theme }) => ({
    maxWidth: 500,
    margin: 'auto',
    padding: theme.spacing(3),
    borderRadius: 24,
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
    backdropFilter: 'blur(6px)',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',

}));

const LoginCardContent = styled(Grid)(({ theme }) => ({
    paddingTop: theme.spacing(4),
}));

const ForgotPasswordButton = styled(Button)(({theme}) => ({
  textTransform: 'capitalize',
  fontSize: 12,
  fontWeight: 'bold',
  padding: 0,
  minWidth: 'auto',
  color:theme.palette.button.primary,
  fontFamily: 'Lato',
  marginLeft: 'auto',
  '&:hover': {
    textDecoration: 'underline',
    backgroundColor: 'transparent',
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  height: 40,
  fontWeight: 'bold',
  fontFamily: 'Lato',
  borderRadius: '11px',
  textTransform: 'none',
  boxShadow: theme.shadows[2],
  color: '#ffffff',
  marginTop: theme.spacing(3),
}));


const VersionText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Lato',
  color: '#5e708eff',
  marginTop: theme.spacing(2),
}));

// const baseStyles = {
//     borderRadius: '4px !important',
// };


const LoginComponent = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loginErrorMessage = useSelector((state) => state.commonStates.loginErrorMessage);

  const [loginInput, setLoginInput] = useState({
    email: '', password: ''
  })
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [botTrapText, setBotTrapText] = useState("");

  const [showNotify, setShowNotify] = useState("hide");
  const [notifyDescription, setNotifyDescription] = useState("");
  const [notifyType, setNotifyType] = useState("success");
  const [notifyPrimaryText, setNotifyPrimaryText] = useState("")
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const setShowLoadingBar = useContext(LoadingContext);

  const onValueChange = (fieldItem) => {
    let inputVal = fieldItem.target.value;
    if (fieldItem.target.name === "txtUsername") {
      setLoginInput({ ...loginInput, email: inputVal });
      if (inputVal.trim() !== "") setUsernameError(false);
    } else if (fieldItem.target.name === "txtPassword") {
      setLoginInput({ ...loginInput, password: inputVal });
      if (inputVal.trim() !== "") setPasswordError(false);
    } else if (fieldItem.target.name === 'botTrapText') {
      setBotTrapText(inputVal);
    }
    // setLoginError("");
  };

  useEffect(() => {
    // Keep your initial cleanup logic
    localStorage.removeItem("passwordExpired");
    localStorage.removeItem("userID");
    localStorage.removeItem("routeState");

    if (loginErrorMessage) {
        const messages = {
            badAuthorizationHeader: i18n.t("login.badAuthorizationHeader"),
            tokenInvalidatedPasswordChange: i18n.t("login.tokenInvalidatedPasswordChange"),
            sessionOut: i18n.t("login.sessionExpiryText")
        };

        showNotifyWindow(
            'show',
            'error',
            messages[loginErrorMessage] || i18n.t("login.sessionExpiryText"),
            5000
        );

        // Clear it so the message doesn't pop up again on refresh
        dispatch({ 
            type: "commonStates/setCommonState", 
            payload: { name: "loginErrorMessage", value: null } 
        });
    }
}, [loginErrorMessage, dispatch]);


  useEffect(() => {
    const userGroupData = JSON.parse(getStorage("userData") || "{}");
    if (userGroupData?.accessToken) {
      if (getStorage("isAdminModule") === 'false') {
        history.push(getPathToRouteOnLoginToPractice(JSON.parse(getStorage("practiceModuleMenuSet") || "[]")))
      }
      else {
        history.push(getPathToRouteOnLoginToAdminModule(JSON.parse(getStorage("adminModuleMenuSet") || "[]")))
      }
    }
  }, [])


  const handleSubmit = (e) => {
    e.preventDefault();
    let retValue = true;
    if (botTrapText) return;
    if (loginInput.email.trim() === "") {
      setUsernameError(true);
      retValue = false;
    }
    if (loginInput.password.trim() === "") {
      setPasswordError(true);
      retValue = false;
    }

    if (!retValue) return retValue;

    setShowLoadingBar(true);
    let data = {
      username: loginInput.email, password: loginInput.password
    }
    service
      .UserLogin(data)
      .then((response) => {
        setShowLoadingBar(false);
        if (response.status === 429) {
          return;
        }
        if (response.status === 426) {
          setStorage("passwordExpired", true);
          setStorage("userID", response.data.user_id);
          history.push(ROUTE_FORCE_RESET_PASSWORD);
        }
        if (response.data.status === "success") {
          let loginResponse = response.data;

          // Route user to admin module when user has no practices and the user type is superAdmin or aimaStaffUser
          if (!loginResponse?.data?.default_practice && (loginResponse?.data?.user_type === 'staff_user' || loginResponse?.data?.user_type === 'superadmin')) {
            setStorage("isAdminModule", true);
          } else {
            setStorage("isAdminModule", false);
          }

          if (window.SharedWorker) {
            workerManager.setActivity(Date.now());
          }
          setStorage("lastActiveMenu", "");
          let resObject = {
            refreshToken: loginResponse.tokens.refresh,
            accessToken: loginResponse.tokens.access,
            user_id: loginResponse.data.user_id,
            username: loginResponse.data.username,
            group_id: loginResponse.data.group_id,
            group_name: loginResponse.data.group_name,
            profile_id: loginResponse.data.profile_id,
            profile_name: loginResponse.data.profile_name,
            profile_image: loginResponse.data.profile_image,
            avatar_name: loginResponse.data.avatar_name,
            company_name: loginResponse.data.company_name,
            practice: loginResponse.data.default_practice,
            custom_practice_id: loginResponse?.data?.custom_practice_id,
            unid: loginResponse.unid,
            view_client_escalation: loginResponse?.data?.role_permissions?.can_view_client_escalations ?? false,
            initiate_client_escalation: loginResponse?.data?.role_permissions?.can_initiate_client_escalation ?? false
          };

          setStorage("super", JSON.stringify(resObject));
          setStorage("userData", JSON.stringify(resObject));
          setStorage("enable_advance_fee_schedule", JSON.stringify(loginResponse?.data?.enable_advance_fee_schedule ?? false));
          setStorage("isAdmin", (loginResponse.data.is_superuser === true || loginResponse.data.user_type === "staff_user"));
          // Process the response to retrieve sidebar menu set and permission keys
          const practiceModuleMenuSet = [];
          const adminModuleMenuSet = [];

          loginResponse.data?.role_permissions?.practice_role_permissions?.forEach((item) => {
            // When the module item is of practice module
            if (item.is_super_admin_module === false) {
              // get the sub module lists for sidebar
              const subModules = [];
              item.sub_module?.forEach((subItem) => {
                if (subItem?.system_generated === false) {
                  subModules.push({
                    ...subItem.ui_integration_data
                  })
                }
              });
              // Pushing the module and its sub item to practice module menu along with a dummy sub item
              // that is needed for utility 
              practiceModuleMenuSet.push({
                ...item.ui_integration_data,
                sub_menu:
                  subModules?.length ? subModules : []
              });

              
            } else if (item.is_super_admin_module === true) {
              // get the sub module lists for sidebar
              const subModules = [];
              item.sub_module?.forEach((subItem) => {
                if (subItem?.system_generated === false) {
                  subModules.push({
                    ...subItem.ui_integration_data
                  })
                }
              });
              // Pushing the module and its sub item to admin module menu set along with a dummy sub item
              // that is needed for utility
              adminModuleMenuSet.push({
                ...item.ui_integration_data,
                sub_menu: subModules?.length ?
                  subModules : []
              });
            }
          });
          
          const practicePermissionCodes = extractPermissions(loginResponse.data?.role_permissions?.practice_role_permissions);
          const userPermissionCodes = (loginResponse.data?.role_permissions?.user_role_permissions || []).reduce((acc, item) => {
            if (item?.codename) {
              acc[item.codename] = true;
            }
            return acc;
          }, {});
          const permissionCodeSet = { ...practicePermissionCodes, ...userPermissionCodes };


          // This code sets, the menu's route to a sub-menu item's route if no matching route is found in sub-menu,
          //  offering a default route based on sub-menu content when conditions allow.
          practiceModuleMenuSet.forEach((menu, index) => {
            if (menu.sub_menu?.length && menu.route !== '#') {
              const defaultRoute = menu?.route;
              const defaultSubMenuAvailable = menu?.sub_menu?.findIndex((item) => item?.route === defaultRoute);

              if (defaultSubMenuAvailable === -1) {
                const defaultSubMenuToSet = menu?.sub_menu?.find((item) => item?.route !== '#')?.route ?? menu?.route;

                if (defaultSubMenuToSet) {
                  practiceModuleMenuSet[index].route = defaultSubMenuToSet;
                }
              }
            }
          });

          practiceModuleMenuSet.forEach((item, index) => {
            if (!item?.sub_menu[0]) {
              practiceModuleMenuSet[index].sub_menu = []
            }
          })

          adminModuleMenuSet.forEach((item, index) => {
            if (!item?.sub_menu[0]) {
              adminModuleMenuSet[index].sub_menu = []
            }
          })

          setStorage('practiceModuleMenuSet', JSON.stringify(practiceModuleMenuSet));
          setStorage('adminModuleMenuSet', JSON.stringify(adminModuleMenuSet));
          setStorage('permissionCodeSet', JSON.stringify(permissionCodeSet));

          if (!loginResponse.data.default_practice) {
            localStorage.removeItem("practice");
            setStorage("practiceName", "");
            if (loginResponse?.data?.user_type === 'staff_user' || loginResponse?.data?.user_type === 'superadmin') {
              setStorage("isAdminModule", true);
              setStorage("isAdmin", true);
              if (loginResponse.data.is_superuser) {
                setStorage("isSuperUser", true);
              }
              // Route the user dynamically to the first page they have access to in admin module
              history.push(getPathToRouteOnLoginToAdminModule(adminModuleMenuSet))
            } else if (loginResponse?.data?.user_type !== 'staff_user' && loginResponse?.data?.user_type !== 'superadmin') {
              setStorage("isSuperUser", false);
              history.push(ROUTE_PRACTICES);
            }
          } else {
            setStorage("practice", loginResponse.data.default_practice);
            setStorage("custom_practice_id", loginResponse.data.custom_practice_id);
            setStorage(
              "practiceName",
              loginResponse.data.default_practice_name
            );
            history.push(getPathToRouteOnLoginToPractice(practiceModuleMenuSet))
          }
          dispatch(setInitialState());
          dispatch(setOtherBillingInitalState());
        }
        if (response.data.error_message === "account_locked_due_three_failed_attempt") {
          setLoginError("Account has been locked out, contact administrator or retry after 30 mins.");
          showNotifyWindow("show", "error", 'Your account has been locked, please either wait for 30 mins to retry or contact admin to unlock the accout manually.', 6000, "Account Locked.");
        }
        if (response.data.error_message === "password_incorrect") {
          setLoginError(
            "Incorrect password. You have " + `${response.data.remaining_attempt}` + " remaining attempts.");
        }
        if (response.data.error_message === "inactive_user") {
          setLoginError("User is Inactive, Please contact the administrator.");
        }
        if (response.data.error_message === 'user_not_exists') {
          setLoginError("Not registered, Please contact administrator.");
        }
      })
      .catch((error) => {
        if (error?.response?.status === 408) {
          localStorage.removeItem("practice");
          localStorage.removeItem("practiceName");
          localStorage.removeItem("userData");
          localStorage.removeItem("isAdminModule");
          history.push(LOGIN_ROUTE);
        }
        showNotifyWindow(
          'show',
          'error',
          "Unexpected error occured please try again"
        );
        setShowLoadingBar(false)
      });
  };


  function showNotifyWindow(action, type, desc, age = 3000, primaryText) {
    if (action === "show") {
      setTimeout(() => {
        setShowNotify("hide");
        setNotifyPrimaryText("");
      }, age);
    }
    setShowNotify(action);
    setNotifyType(type);
    setNotifyDescription(desc);
    setNotifyPrimaryText(primaryText)
  }

  const closeErrorAlert = () => {
    setLoginError("");
  };

  /**
   * function to reset username 
   * @param {*} e 
   */
  function onShowUserName(e) {
    e.preventDefault();
    history.push(ROUTE_FORGOT_SEND_MAIL)
  }

      // const inputStylesEmail = {
      //   ...baseStyles,
      //   ...usernameError ? errorBorder : normalBorder}

      // const inputStylesPassWord = {
      //   ...baseStyles,
      //   ... passwordError ? errorBorder : normalBorder,
      // };

  return (
    <RootContainer container component="main">
      <Notify
        showNotify={showNotify}
        notifyPrimaryText={notifyPrimaryText}
        setShowNotify={setShowNotify}
        notifyDescription={notifyDescription}
        setNotifyType={setNotifyType}
        setNotifyDescription={setNotifyDescription}
        notifyType={notifyType}
      />
      <CssBaseline />
      <Grid item xs={12} sx={{ pt: 4 }}>
        <PaperWrapper>
          <Box width="100%" maxWidth={400} py={4}>
            <LoginCardBox>
              <LoginCardContainer container justifyContent="center">
                <LoginCardContent item xs={12}>
                  <LoginHeader type="login" />
                  <LoginErrorAlert loginError={loginError} closeErrorAlert={closeErrorAlert} />
                  <form onSubmit={handleSubmit}>
                    <Box sx={{mt:2}}>
                      <Label label="Email" fontWeight="bold" color="#576b8d" />
                      <TextField
                        type="text"
                        id="txtUsername"
                        name="txtUsername"
                        variant="outlined"
                        placeholder="Enter your email"
                        onChange={onValueChange}
                        value={loginInput.email}
                        fullWidth
                        size="small"
                        error={usernameError}
                      />
                    </Box>

                    <Box sx={{mt:2}}>
                      <Label label="Password" fontWeight="bold" color="#576b8d" />
                      <TextField
                        variant="outlined"
                        type={showPassword ? 'text' : 'password'}
                        id="txtPassword"
                        name="txtPassword"
                        placeholder="Enter your password"
                        onChange={onValueChange}
                        value={loginInput.password}
                        fullWidth
                        size="small"  
                        error={passwordError}
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                              edge="end"
                              sx={{ mr: 0.2 }}
                            >
                              {showPassword ? (
                                <VisibilityOffOutlinedIcon />
                              ) : (
                                <VisibilityOutlinedIcon />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </Box>

                    {/* Bot Trap */}
                    <Box id="mslcns" sx={{ display: 'none' }}>
                      <Label label="Text" fontWeight="bold" color="#576b8d" />
                      <TextField
                        variant="outlined"
                        type="text"
                        id="botTrapText"
                        name="botTrapText"
                        onChange={(e) => setBotTrapText(e.target.value)}
                        value={botTrapText}
                      />
                    </Box>

                    <Box display="flex" justifyContent="flex-end" mt={2}>
                      <ForgotPasswordButton onClick={(e) => onShowUserName(e)}>
                        Forgot Password?
                      </ForgotPasswordButton>
                    </Box>

                    <SubmitButton
                      type="submit"
                      variant="contained"
                      fullWidth
                      startIcon={<ExitToAppIcon />}
                      disableRipple   //disables the white moving glow
                      disableFocusRipple //disables focus ripple
                    >
                      Sign in
                    </SubmitButton>
                  </form>
                </LoginCardContent>
              </LoginCardContainer>
            </LoginCardBox>
          </Box>
        </PaperWrapper>
        <Box>
          <VersionText variant="body2" align="center">
            Copyright AIMA Business & Medical Support LLC © All Rights Reserved.
            {' '}Version {packageJson.version}
          </VersionText>
        </Box>
      </Grid>
    </RootContainer>
  );
}

export default LoginComponent;